import { Component, Vue } from 'vue-property-decorator'
import { querySummaryeduLogs } from '@/api'
import HighFilter from '@/components/highFilter/index.vue'
@Component({ name: 'class-list-page', components: { HighFilter } })
export default class ClassListPage extends Vue {
  private tableData = []
  private totalPage = 1;
  private currentPage = 1;
  private classChoose = ''
  private filterData: any = {};
  private filterResult: any = null
  private showHighFilter = false
  private tableloading: any =false
  created () {
    this.initPageData()
  }

  private async initPageData () {
    this.tableloading = true
    const param: any = { page: this.currentPage, limit: 20 }
    if (this.filterResult) {
      param.search = this.filterResult
    }
    const result: any = await querySummaryeduLogs(param)
    this.totalPage = result.allPage
    this.currentPage = result.currentPage
    this.tableData = result.logs
    this.filterData = result.search
    this.tableloading = false
  }

  /**
  * [description] 分页切换回调函数
  */
  private async onPageChange () {
    this.initPageData()
  }

  private async onFilterResult (data: any) {
    this.filterResult = data
    this.currentPage = 1
    await this.initPageData()
    this.showHighFilter = false
  }
}
